import { apiClient } from "../client";

export const listQuestionnaires = async (params = {}) => {
  const { data } = await apiClient.get("/questionnaires", { params });
  return data;
};

export const listQuestionnairesWithMeta = async (params = {}) => {
  const { data } = await apiClient.get("/questionnaires", {
    params: { ...params, include_meta: "1" },
  });
  return data;
};

export const getQuestionnaireById = async (questionnaireId) => {
  const { data } = await apiClient.get(`/questionnaires/${questionnaireId}`);
  return data;
};

export const createQuestionnaire = async (payload) => {
  const { data } = await apiClient.post("/questionnaires", payload);
  return data;
};

export const updateQuestionnaire = async (questionnaireId, payload) => {
  const { data } = await apiClient.patch(`/questionnaires/${questionnaireId}`, payload);
  return data;
};

export const updateQuestionnaireSchema = async (questionnaireId, schema) => {
  const { data } = await apiClient.patch(`/questionnaires/${questionnaireId}/schema`, {
    schema,
  });
  return data;
};

export const duplicateQuestionnaire = async (questionnaireId, payload) => {
  const { data } = await apiClient.post(
    `/questionnaires/${questionnaireId}/duplicate`,
    payload
  );
  return data;
};

export const getQuestionnaireClassroomStatus = async (questionnaireId, turmaId) => {
  const { data } = await apiClient.get(
    `/questionnaires/${questionnaireId}/classrooms/${turmaId}/status`
  );
  return data;
};

export const enableQuestionnaireForClassroom = async (
  questionnaireId,
  turmaId,
  classroomName
) => {
  const { data } = await apiClient.post(
    `/questionnaires/${questionnaireId}/classrooms/${turmaId}/enable`,
    { classroom_name: classroomName }
  );
  return data;
};

export const disableQuestionnaireForClassroom = async (questionnaireId, turmaId) => {
  const { data } = await apiClient.post(
    `/questionnaires/${questionnaireId}/classrooms/${turmaId}/disable`
  );
  return data;
};

export const getQuestionnaireDashboardReports = async (questionnaireId, turmaId) => {
  const { data } = await apiClient.get(
    `/questionnaires/${questionnaireId}/report/dashboard`,
    { params: turmaId ? { turma_id: turmaId } : {} }
  );
  return data;
};

export const getQuestionnaireCompletionReport = async (questionnaireId, turmaId) => {
  const { data } = await apiClient.get(
    `/questionnaires/${questionnaireId}/report/completion`,
    { params: turmaId ? { turma_id: turmaId } : {} }
  );
  return data;
};

export const getQuestionnaireSummaryReport = async (questionnaireId, turmaId) => {
  const { data } = await apiClient.get(
    `/questionnaires/${questionnaireId}/report/summary`,
    { params: turmaId ? { turma_id: turmaId } : {} }
  );
  return data;
};

export const getQuestionnaireTextAnswersReport = async (questionnaireId, turmaId) => {
  const { data } = await apiClient.get(
    `/questionnaires/${questionnaireId}/report/text-answers`,
    { params: turmaId ? { turma_id: turmaId } : {} }
  );
  return data;
};

export const getQuestionnaireExportReport = async (questionnaireId, turmaId = null) => {
  const { data } = await apiClient.get(
    `/questionnaires/${questionnaireId}/report/export`,
    { params: turmaId ? { turma_id: turmaId } : {} }
  );
  return data;
};
